import { render } from "./ScoreSelect.vue?vue&type=template&id=12e66f35&scoped=true"
import script from "./ScoreSelect.vue?vue&type=script&lang=js"
export * from "./ScoreSelect.vue?vue&type=script&lang=js"

import "./ScoreSelect.vue?vue&type=style&index=0&id=12e66f35&lang=less&scoped=true"

import exportComponent from "/builds/maizhensheng/app-commonapply-v6/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e66f35"]])

export default __exports__